import "./body.css";

import FlashMessage from "./FlashMessage";

export default function Body({ children }) {
  return (
    <div className="wrapper">
      {children}
    </div>
  );
}
